import React from "react";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers/index";
// import { Link } from "react-router-dom";

// import "./App.css";

import Home from "./pages/homepage/Home";
import Login from "./pages/login/Login";
import SignUp from "./pages/signup/Register";
import Templates from "./pages/templates/Templates";
import Settings from "./pages/settings/Settings";
import Password from "./pages/password/password";
import Mystores from "./pages/mystores/Mystores";
import Preview from "./pages/preview/Preview";
import Editor from "./pages/editor/Editor";
import Template from "./pages/template/Template";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import { withLayout } from "./components/layout/Layout";

const store = createStore(rootReducer, applyMiddleware(thunk));

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <RouteWrapper exact path="/" component={Home} layout={withLayout} />
          <RouteWrapper
            exact
            path="/login"
            component={Login}
            layout={withLayout}
          />
          <RouteWrapper
            exact
            path="/register"
            component={SignUp}
            layout={withLayout}
          />
          <RouteWrapper
            exact
            path="/templates"
            component={Templates}
            layout={withLayout}
          />
          <RouteWrapper
            exact
            path="/settings"
            component={Settings}
            layout={withLayout}
          />
          <RouteWrapper
            exact
            path="/newPasswordRequest"
            component={Password}
            layout={withLayout}
          />
          <RouteWrapper
            exact
            path="/mystores"
            component={Mystores}
            layout={withLayout}
          />
          <RouteWrapper path="/editor/:storeId" exact component={Editor} layout={withLayout}/>
          <Route exact path="/preview/:storeId" component={Preview} />
          <Route exact path="/template/:templateId" component={Template} />
        </Switch>

        {/* <Route path="/" exact component={Home} />
        <Route path="/login" exact component={Login} />
        <Route path="/register" exact component={SignUp} />
        <Route path="/templates" excat component={Templates} />
        <Route
          path="/settings"
          exact
          component={Settings}
        />
        <Route path="/newPasswordRequest" exact component={Password} />
        <Route path="/mystores" exact component={Mystores} />
        <Route path="/preview/:storeId" exact component={Preview} />
        <Route path="/editor" exact component={Editor}/>
        <Route path="/preview/:storeId" exact component={Preview} /> */}
      </Router>
    </Provider>
  );
}

function RouteWrapper({ component: Component, layout: Layout, ...rest }) {
  // // console.log(Component, Layout);
  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout {...props}>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}

export default App;
